// Auto-generated by scripts/bump-build-version.js — do not edit by hand.
// Bumped automatically by `npm run deploy` so the running bundle
// carries an unambiguous version string.
export const BUILD_VERSION = "1.1.44";
export const BUILD_TIMESTAMP = "2026-11-03T01:00:22.998Z";
